import { render } from "./CardSubtitle.vue?vue&type=template&id=0f8524fa"
import script from "./CardSubtitle.vue?vue&type=script&lang=js"
export * from "./CardSubtitle.vue?vue&type=script&lang=js"
script.render = render

export default script